"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Empty = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var i18n_1 = require("../../i18n");
var dropdown_1 = require("../../dropdown");
var list_1 = require("../../list");
var text_1 = require("../../text");
exports.Empty = function (_a) {
    var offset = _a.offset, onCancel = _a.onCancel, emptyText = _a.emptyText;
    var t = i18n_1.useTranslation();
    return (react_1.default.createElement(dropdown_1.DropdownBox, { style: { marginLeft: offset } },
        react_1.default.createElement(list_1.List, { type: "option" },
            react_1.default.createElement(list_1.List.Item, { onClick: onCancel },
                react_1.default.createElement(text_1.Text, { theme: "label" }, emptyText || t.emptyText)))));
};
//# sourceMappingURL=Empty.js.map